import React from 'react'
import './loader.scss'

const Loader: React.FC = () => {
  return (
    <div className='web-loader'>
      <span className='logo'>
        <img src='../images/logo_ic.svg' alt='Logo' />
      </span>
      <span className='loader-text'>Loading...</span>
    </div>
  )
}

export default Loader
